import {
  DeleteOutlined,
  FieldTimeOutlined
} from '@ant-design/icons'
import { Button, Empty, Form, message, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useEffect, useMemo, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'; // Import uuid
import {
  convertPriceToNumber,
  formatCurrencyLabel,
  getLabelByValue,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { departmentSearch } from '../../services/cmsservice'
import {
  addressSearch,
  addressSearchAll,
  getListUserDepartment,
  getUserManagePost,
  postAdd,
  postDelete,
  postDetail,
  postSearch,
  postUpdate,
  projectSearch,
  upLoadImage
} from '../../services/postservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import DuplicateSell from './DuplicateSell'
import Note from './Note'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  getSubProductType,
  LabelType,
  POLICY_DOCUMENT,
  PROCCESS_TRANFER,
  ProductType,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
import { duplicatePostDelete, duplicatePostSearch } from '../../services/duplicate-post-service'
import DuplicateRent from './DuplicateRent'
import Loading from '../Loading';

export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}

const DuplicatePostManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listDepartment, setListDepartment] = useState([])
  const [data, setData] = useState([])
  // Form thêm mới
  const [loading, setLoading] = useState(false)
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })
  // const [listUser, setListUser] = useState([])
  const [listProject, setListProject] = useState([])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isOpenSell, setIsOpenSell] = useState(false)
  const [isOpenRent, setIsOpenRent] = useState(false)
  // Lấy tên quản lý tin theo id bản ghi

  const [record, setRecord] = useState()
  const [isModalNote, setIsModalNote] = useState(false)
  const user_role = localStorage.getItem('user_role')

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 150,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.customer_phone_number}
          postId={record?.id}
        />
      )
    },
    // {
    //   title: 'Email',
    //   dataIndex: 'customer_email',
    //   key: 'customer_email'
    // },
    {
      title: 'Người đăng tin',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <span>{record?.user_info?.name}</span>
      }
    },
    {
      title: 'SĐT người đăng tin',
      dataIndex: 'phone',
      key: 'phone',
      width: 200,
      render: (_, record) => {
        return (
          <PhoneVisibilityCell
            value={record?.user_info?.phone}
            postId={record?.id}
          />
        )
      }
    },
    {
      title: 'Tên Sàn',
      dataIndex: 'department_id',
      key: 'department_id',
      width: 120,
      render: (_, record, index) => {
        const name = listDepartment.find(
          (n) => n.id === record.department_id
        )?.name
        return <span>{name}</span>
      }
    },
    {
      title: 'Quản lý tin',
      dataIndex: 'manager_post_id',
      key: 'manager_post_id',
      width: 150,
      // render: (text, record) => {
      //   const userIds = record.post_manager_info.map(
      //     (post) => post.manager_post_id
      //   )

      //   const names = listUserDepartment
      //     .filter((user) => userIds.includes(user.id))
      //     .map((user) => user.name)
      //     .join(', ')
      //   // getListUserPost(record.id)
      //   return <>{names}</>
      // }
      // render: (text) => <span>{'Ko biết'}</span>
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      width: 90,
      render: (_, record) => (
        <span>
          {LabelType.find((n) => n.value === record.label)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 150,
      render: (_, record) => (
        <span>
          {ProductType.find((n) => n.value === record.post_type)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>{getLabelByValue(record.type_real_estate)}</span>
      )
    },
    {
      title: 'Dự án',
      dataIndex: 'project_id',
      key: 'project_id',
      width: 200,
      render: (_, record) => (
        <span>
          {listProject.find((n) => n.id === record.project_id)?.project_name ||
            ''}
        </span>
      )
    },
    {
      title: 'Số địa chỉ',
      dataIndex: 'alley',
      key: 'alley',
      width: 150,
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 120,
    },
    {
      title: 'Toà',
      dataIndex: 'building',
      key: 'building',
      width: 100,
    },
    {
      title: 'Tầng',
      dataIndex: 'floor',
      key: 'floor',
      width: 80,
    },
    {
      title: 'Số căn',
      dataIndex: 'number_of_rooms',
      key: 'number_of_rooms',
      width: 80,
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 130,
    },
    {
      title: 'Số WC',
      dataIndex: 'number_of_wc',
      key: 'number_of_wc',
      width: 80,
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 130,
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 130,
    },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 120,
      render: (_, record) => (
        <span>
          {APARTMENT_TYPE.find((n) => n.value === record.apartment_location)
            ?.label || record.apartment_location}
        </span>
      )
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 120,
      render: (_, record) => (
        <span>
          {BALCONY_DIRECTION.find((n) => n.value === record.direction)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Nội thất',
      dataIndex: 'furniture',
      key: 'furniture',
      width: 120,
      render: (_, record) => (
        <span>
          {FURNITURE_TYPE.find((n) => n.value === record.furniture)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Giấy tờ pháp lý',
      dataIndex: 'legal',
      key: 'legal',
      width: 150,
      render: (_, record) => (
        <span>
          {POLICY_DOCUMENT.find((n) => n.value === record.legal)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Phí giao dịch',
      dataIndex: 'procedure',
      key: 'procedure',
      width: 150,
      render: (_, record) => (
        <span>
          {PROCCESS_TRANFER.find((n) => n.value === record.procedure)?.label ||
            ''}
        </span>
      )
    },

    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      width: 80,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Phí môi giới',
      dataIndex: 'cost',
      key: 'cost',
      width: 120,
      render: (_, record) => <span>{formatCurrencyLabel(record.cost)}</span>
    },
    {
      title: 'Hiện trạng',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (_, record) => (
        <span>
          {status.find((n) => n.value === record.status)?.label || ''}
        </span>
      )
    },
    {
      title: 'Trạng thái tin',
      dataIndex: 'processing_status',
      key: 'processing_status',
      width: 150,
      render: (_, record) => (
        <span>
          {statusList.find((n) => n.value === record.processing_status)?.label || ''}
        </span>
      )
    },

    {
      title: 'Bảo mật thông tin',
      dataIndex: 'security',
      key: 'security',
      width: 170,
      render: (_, record) => (
        <span>
          {SECURITY_TYPE.find((n) => n.value === record.security)?.label || ''}
        </span>
      )
    },   
    // {
    //   title: 'Note',
    //   dataIndex: 'note',
    //   key: 'note'
    // },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      width: 120,
    },
 
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.city_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.district_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_code',
      key: 'town_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.town_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 150,
    },
    {
      title: 'Email',
      width: 100,
      dataIndex: 'customer_email',
      key: 'customer_email'
    },

    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Thời gian cập nhật',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (_, record) => (
        <span>
          {record?.updated_at
            ? dayjs.unix(record?.updated_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
   
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {/* {hasPermission('P37.5', permissions) && ( */}
              <Tooltip title="Tin trùng bán">
                <Button
                  onClick={() => {
                    setRecord(record)
                    setIsOpenSell(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Tin trùng bán
                </Button>
              </Tooltip>
            {/* )} */}

            {/* {hasPermission('P37.6', permissions) && ( */}
              <Tooltip title="Tin trùng thuê">
                <Button
                  onClick={() => {
                    setRecord(record)
                    setIsOpenRent(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Tin trùng thuê
                </Button>
              </Tooltip>
            {/* )} */}
            {record.status !== 'inactive' &&
              hasPermission('P76.1', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá tin
                            <b> {record.title}</b> không?
                          </div>
                        ),
                        onOk: () => deletePost(record.id)
                      })
                    }
                  />
                </Tooltip>
              )}
          </Space>
        )
      }
    }
  ]

  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e)
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))

    // Reset value and error for project_id
    form.setFields([
      {
        name: 'project_id',
        errors: []
      }
    ])
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }

  // Lấy danh sách post
  const getListPost = async (values = {}) => {
    setLoading(true)

    const value = removeNullUndefined(values)
    try {
      const body = { ...value, type_new: 1, page: pagination.current, pageSize: pagination.pageSize }
      const res = await duplicatePostSearch(body)

      setData(res.data)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      getListPost({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  // Danh sách sàn
  const getDepartmentAll = async (values) => {
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name, type, page, pageSize }
      const res = await departmentSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      }))
      setListDepartment(result)
    } catch (err) {}
  }

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListProject(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }
  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách phường xã
  const getListTowns = async (code) => {
    // const type = 'town'
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getDepartmentAll()
    getProjectAll()
    getListCities()
  }, [])

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  const [listUserDepartment, setListUserDepartment] = useState([])
  // Danh sách tài khoản theo SÀN
  const getUserDepartment = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListUserDepartment(body) // Assuming roleSearch is an API function
      if (res && res.data.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUserDepartment(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUserDepartment([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
      // You might want to show a notification or alert to the user here
      setListUserDepartment([]) // Optionally, reset the list to an empty array
    }
  }

  useEffect(() => {
    const department_id = localStorage.getItem('department_id')
    if (user_role === 'ADMIN') {
      getUserDepartment('')
    } else {
      getUserDepartment(department_id)
    }
  }, [])

  const onChangeDepartment = async (value) => {
    await getUserDepartment(value)

    form.setFieldsValue({
      manager_post_id: null
    })
  }

  // Xóa tin
  const deletePost = async (ids) => {
    setLoading(true)
    try {
      const body = {
        id: ids,
        from: 2
      }
      const res = await duplicatePostDelete(body)
      getListPost()
      setSelectedRowKeys([])
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const [citiesAll, setCitiesAll] = useState([])
  const [districtsAll, setDistrictsAll] = useState([])
  const [townsAll, setTownsAll] = useState([])

  // Danh sách thành phố
  const getListCitiesAll = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCitiesAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách quận huyện
  const getListDistrictsAll = async () => {
    try {
      const res = await addressSearchAll('district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setDistrictsAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách phường xã
  const getListTownsAll = async () => {
    try {
      const res = await addressSearchAll('town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setTownsAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getListCitiesAll()
    getListDistrictsAll()
    getListTownsAll()
  }, [])

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          getListPost={getListPost}
          listDepartment={listDepartment}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          user={listUserDepartment}
          onChangePostType={onChangePostType}
          listTypeRealEstate={typeRealEstate}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
            {hasPermission('P76.1', permissions) && (
              <Button
                danger
                // disabled={selectedRowKeys.length > 0 ? false : true}
                type="primary"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    openNotification('error', 'Vui lòng chọn tin')
                  } else {
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá{' '}
                          <b>{selectedRowKeys?.length}</b> tin không?
                        </div>
                      ),
                      onOk: () => deletePost(selectedRowKeys)
                    })
                  }
                }}
              >
                <DeleteOutlined />
                Xoá
              </Button>
            )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={data?.list}
          scroll={{ x: data?.list?.length > 0 ? 'max-content' : '100%', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
      </Card>

      <ModalCustom
        title="Danh sách quản lý note"
        visible={isModalNote}
        centered
        width={600}
        onCancel={() => {
          setIsModalNote(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Note postId={record} getListPost={getListPost}/>
      </ModalCustom>
      <DuplicateSell 
      getListPost={getListPost}
      item={record} 
      isOpen={isOpenSell} 
      setIsOpen={setIsOpenSell} 
      listDepartment={listDepartment}
      cities={citiesAll}
      districts={districtsAll}
      towns={townsAll}
      listProject={listProject}
      />

    <DuplicateRent
      getListPost={getListPost}
      item={record} 
      isOpen={isOpenRent} 
      setIsOpen={setIsOpenRent} 
      listDepartment={listDepartment}
      cities={citiesAll}
      districts={districtsAll}
      towns={townsAll}
      listProject={listProject}
      />
    
      <ModalConfirm />
    </div>
  )
}

export default DuplicatePostManagement
